import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import AdminFileManagement from './pages/AdminFileManagement';
import AdminUsers from './pages/AdminUsers';
import AdminRequiries from './pages/AdminRequiries';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <div className="app">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <div className="dashboard-layout">
                  <Header />
                  <div className="dashboard-content">
                    <Sidebar />
                    <main className="main-content">
                      <Routes>
                        <Route path="/" element={<AdminDashboard />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/admin/files" element={<AdminFileManagement />} />
                        <Route path="/admin/requiries" element={<AdminRequiries />} />
                        <Route path="/admin/users" element={<AdminUsers />} />
                      </Routes>
                    </main>
                  </div>
                </div>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
